const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function validateForgotPasswordEmail(value: string): string | null {
  const email = value.trim();

  if (!email) {
    return 'Informe o e-mail cadastrado.';
  }

  if (!EMAIL_PATTERN.test(email)) {
    return 'Informe um e-mail válido.';
  }

  return null;
}

export function forgotPasswordEmail(value: string): string {
  return value.trim();
}

export interface PasswordRuleState {
  letter: boolean | null;
  number: boolean | null;
  match: boolean | null;
  novaValid: boolean;
  novaInvalid: boolean;
  repetirValid: boolean;
  repetirInvalid: boolean;
}

export function passwordRuleState(
  novaSenha: string,
  repetirSenha: string,
): PasswordRuleState {
  const hasLetter = /[a-zA-Z]/.test(novaSenha);
  const hasNumber = /\d/.test(novaSenha);
  const hasTyped = novaSenha.length > 0;
  const hasConfirm = repetirSenha.length > 0;
  const matches = hasTyped && hasConfirm && novaSenha === repetirSenha;

  return {
    letter: hasTyped ? hasLetter : null,
    number: hasTyped ? hasNumber : null,
    match: hasConfirm ? matches : null,
    novaValid: hasTyped && hasLetter && hasNumber,
    novaInvalid: hasTyped && (!hasLetter || !hasNumber),
    repetirValid: matches,
    repetirInvalid: hasConfirm && !matches,
  };
}

export function validatePasswordChange(
  senhaAtual: string,
  novaSenha: string,
  repetirSenha: string,
): string | null {
  const atual = senhaAtual.trim();

  if (!atual || !novaSenha || !repetirSenha) {
    return 'Preencha todos os campos.';
  }

  if (!/[a-zA-Z]/.test(novaSenha) || !/\d/.test(novaSenha)) {
    return 'A nova senha deve conter letras e números.';
  }

  if (novaSenha !== repetirSenha) {
    return 'As senhas não coincidem.';
  }

  if (atual === novaSenha) {
    return 'A nova senha deve ser diferente da senha atual.';
  }

  return null;
}

export interface PasswordChangeResult {
  senhaAtual: string;
  novaSenha: string;
}
